export const FOOTER_REVEAL_PROPS = { "data-footer-reveal": "" } as const;

export const FOOTER_REVEAL_EDGE_PROPS = {
    "data-footer-reveal-edge": "",
} as const;

export type FooterReveal = { wrapper: Element; edge: Element };

export function findFooterReveal(insideFooter: Element): FooterReveal | null {
    const wrapper = insideFooter.closest("[data-footer-reveal]");
    const edge = wrapper?.parentElement?.querySelector(
        ":scope > [data-footer-reveal-edge]",
    );
    return wrapper && edge ? { wrapper, edge } : null;
}
